<ng-container *ngFor="let item of children; trackBy: trackByFn">
    <ms-tree-item
        [item]="item"
        [hideHeader]="hideHeader"
        (toggle)="onToggle($event)"
        (toggleMarkets)="onToggleMarkets($event)"
        (selectEvent)="onSelectEvent($event)" />
</ng-container>
